import React, { useState, useEffect } from "react";
import { Cookies } from "react-cookie";
import { useNavigate, Link } from "react-router-dom";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import AdminApi from "../../../api/admin";
import RetreatApi from "../../../api/retreatApi";
import Helpers from "../../../components/Helpers";
import DeleteModel from "../../../components/DeleteModel";
import AuthApi from "../../../api/authApi";
import Select from "react-select";
import corruptedImg from "../../../assets/images/corrupted-img.png";
import PriestApi from "../../../api/priestApi";
import SampleContentApi from "../../../api/SampleContentApi";

import {
  Button,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Form,
  Modal,
  Popover,
} from "react-bootstrap";
import CustomDataTable from "../../../components/CustomDataTable";
import { useTranslation } from "react-i18next";
import DatePicker from "../../../components/AppDatePicker";
import SunEditor from "suneditor-react";
import TimePicker from "../../../components/TimePicker";
import uploadRetreat from "../../../assets/images/uploadRetreat.png";
import {
  getRetreatImagePreviewSrc,
  processRetreatImage,
  RETREAT_IMAGE_ACCEPT,
} from "../../../utils/processRetreatImage";
import PhoneInput from "../../../components/PhoneInput";
import CopyableInput from "../../../components/CopyableInput";
import AlertDelete from "../../../components/AlertDelete";
import DescriptionSampleTip from "../../../components/DescriptionSampleTip";
import ViewMailMsg from "../../../components/ViewMailMsg";
import RetreatImageUploadInfo from "../../../components/RetreatImageUploadInfo";
import { formatParishOptionLabel } from "../../../utils/parishLabels";
import { formatCoupleOptionLabel } from "../../../utils/coupleLabels";
import UpdatePriestPopUp from "../../Priest/UpdatePriestPopUp";

const NewRetreats = () => {
  const [total, setTotal] = useState(20);
  const [show, setShow] = useState(false);
  const [searchKey, setSearchKey] = useState(""); //for searching
  const [LoadData, setLoadData] = useState(false);
  const [tempRetreats, setTempRetreats] = useState([]);
  const [tempRetreatDetail, setTempRetreatDetail] = useState([]);
  const [showRegModal, setShowREgModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [missionStatement, setMissionStatement] = useState("");
  const [description, setDescription] = useState("");
  const [emailMsg, setEmailMsg] = useState("");
  const [data, setData] = useState({});
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [dynamicEmailMsg, setDynamicEmailMsg] = useState("");
  const { t, i18n } = useTranslation();
  const [isTempUpload1, setIsTempUpload1] = useState(false);
  const [applyLoader, setApplyLoader] = useState(false);
  const [fromErrorMsg, setFromErrorMsg] = useState(false);
  const [check, setCheck] = useState("");
  const [toErrorMsg, setToErrorMsg] = useState(false);
  const [greenTick, setGreenTick] = useState(false);
  const [parishList, setParishList] = useState([]);
  const [allCoupleMails, setAllCoupleMails] = useState([]);
  const [fullCouples, setFullCouples] = useState([]);
  const [fullPriests, setFullPriests] = useState([]);
  const [accessGreenTick, setAccessGreenTick] = useState(false);
  const [coupleSelectForAccess, setCoupleSelectForAccess] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [Pass, setPass] = useState(false);
  const [timeDate, setTimeDate] = useState({
    date: new Date(),
    from: "00 : 00",
    to: "00 : 00",
  });
  const [descriptionSample, setDescriptionSample] = useState(false);
  const [mailSample, setMailSample] = useState(false);
  const [mailMsgView, setMailMsgView] = useState(false);
  const [showPriestModal, setShowPriestModal] = useState(false);
  const [priestData, setPriestData] = useState({
    id: "",
    primaryKey: "",
    parishId: null,
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    city: "",
    state: "",
    zip: "",
    imageUrl: "",
    address: "",
  });
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [alreadyPk, setAlreadyPk] = useState("");
  const [selectedPriestOption, setSelectedPriestOption] = useState(null);
  const [oldPriestValues, setOldPriestValues] = useState([]);
  const [isTempPriestUpload, setIsTempPriestUpload] = useState(false);
  const [emailErrors, setEmailErrors] = useState({});
  const [isApproveAction, setIsApproveAction] = useState(false);

  let authApi = new AuthApi();
  let adminApi = new AdminApi();
  let retreatApi = new RetreatApi();
  let priestApi = new PriestApi();
  let sampleContentApi = new SampleContentApi();

  const loadDescriptionAndEmailSamples = (lang) => {
    const selectedLang = lang || "english";
    sampleContentApi
      .getSampleContent("Retreat Description", selectedLang)
      .then((res) => {
        if (res.success && res.data) setDynamicDescription(res.data.content);
        else setDynamicDescription("");
      });
    sampleContentApi
      .getSampleContent("Retreat Email Message", selectedLang)
      .then((res) => {
        if (res.success && res.data) setDynamicEmailMsg(res.data.content);
        else setDynamicEmailMsg("");
      });
  };

  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  let navigate = useNavigate();

  useEffect(() => {
    getAllTempRetreats();
    getAllCouples();
    getAllPriests();
    
    getParishList();
  }, []);

  useEffect(() => {
    loadDescriptionAndEmailSamples(data?.language);
    if (data?.language) {
      sampleContentApi
        .getSampleContent("Mission Statement", data.language)
        .then((res) => {
          if (res.success && res.data) setMissionStatement(res.data.content);
        });
    }
  }, [data?.language]);

  const getParishList = async () => {
    await authApi
      .getPerishList()
      .then((response) => {
        const sortedList = response.data.sort((a, b) =>
          a.parish.localeCompare(b.parish),
        );
        setParishList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const defaultRetreatTeam = () => [
    {
      role: "lead_couple",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
    },
    {
      role: "co_lead_couple",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
    },
    {
      role: "mentor_couple",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
    },
    {
      role: "spiritual_director",
      firstName: "",
      lastName: "",
      email: "",
    },
  ];

  const mergeRetreatTeam = (team = []) => {
    const merged = defaultRetreatTeam();
    (team || []).forEach((member) => {
      const idx = merged.findIndex((m) => m.role === member.role);
      if (idx >= 0) {
        merged[idx] = { ...merged[idx], ...member };
      } else {
        merged.push(member);
      }
    });
    return merged;
  };

  const normalizeSchedule = (schedule, fallback = []) => {
    let parsed = fallback;
    if (Array.isArray(schedule)) {
      parsed = schedule;
    } else if (typeof schedule === "string" && schedule.trim()) {
      try {
        parsed = JSON.parse(schedule);
      } catch {
        parsed = fallback;
      }
    }
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.map((entry) => ({
      date: entry?.date ? new Date(entry.date) : "",
      from: entry?.from || "",
      to: entry?.to || "",
      dayName: entry?.dayName || "",
    }));
  };

  const applyEditFormState = (editData) => {
    setData({
      ...editData,
      schedule: normalizeSchedule(editData.schedule, []),
      retreat_team: mergeRetreatTeam(editData.retreat_team || []),
      subAdmins: editData.subAdmins || [],
    });
    setDescription(editData.description || "");
    setEmailMsg(editData.mail_msg || "");
    setMissionStatement(editData.mission_statement || "");
    if (editData.language) {
      i18n.changeLanguage(editData.language);
    }
    const pMember = (editData.retreat_team || []).find(
      (m) => m.role === "spiritual_director",
    );
    if (pMember && pMember.email && fullPriests) {
      const priest = fullPriests.find((p) => p.email === pMember.email);
      if (priest) {
        setSelectedPriestOption({
          label: `${priest.title ? priest.title + " " : ""}${priest.firstName} ${priest.lastName || priest.name}`,
          value: priest.id,
        });
      } else {
        setSelectedPriestOption({
          label: `${pMember.firstName} ${pMember.lastName}`,
          value: editData.priestId || "",
        });
      }
    } else {
      setSelectedPriestOption(null);
    }
  };

  const editCouple = async (row) => {
    try {
      const res = await retreatApi.getRetreatDetail({
        id: row.id,
        isTemp: true,
      });
      if (res.success && res.data && res.data[0]) {
        const detail = res.data[0];
        applyEditFormState({
          ...row,
          ...detail,
          schedule: detail.schedule || row.schedule,
          retreat_team: detail.retreat_team || row.retreat_team || [],
          subAdmins: row.subAdmins || [],
        });
        return;
      }
    } catch (error) {
      console.error("Failed to load retreat detail for edit:", error);
    }
    applyEditFormState(row);
  };

  const handleCloseAlert = () => {
    setDescriptionSample(false);
    setMailSample(false);
  };

  const columns = [
    ...(userData && (userData.userRole === "ADMIN" || userData.access === true)
      ? [
          {
            id: "action_admin",
            name: "Action",
            button: true,
            cell: (row) => (
              <>
                <button
                  className="font-size"
                  onClick={async () => {
                    await editCouple(row);
                    setShowREgModal(true);
                  }}
                >
                  <i
                    className="mdi mdi-pencil-box text-lg text-primary font-size"
                    title="Edit"
                  ></i>
                </button>
                {userData && userData.userRole === "ADMIN" && (
                  <>
                    <button
                      className="font-size action-icons"
                      onClick={() => handleShow(row)}
                    >
                      <i
                        className="mdi mdi-delete-forever text-md text-danger mx-2 font-size"
                        title="Delete"
                      ></i>
                    </button>
                    <button
                      className="font-size action-icons"
                      onClick={async () => {
                        if (
                          window.confirm(
                            "Are you sure you want to approve this Retreat?",
                          )
                        ) {
                          await editCouple(row);
                          // We need to use the data from editCouple since it might have fetched more details
                          // However, editCouple sets state 'data'. We can't wait for state update here easily.
                          // Better to use the detail fetched in editCouple directly if possible.
                          const resDetail = await retreatApi.getRetreatDetail({
                            id: row.id,
                            isTemp: true,
                          });
                          if (
                            resDetail.success &&
                            resDetail.data &&
                            resDetail.data[0]
                          ) {
                            const detail = resDetail.data[0];
                            const stateRef = {
                              ...row,
                              ...detail,
                              schedule: normalizeSchedule(
                                detail.schedule || row.schedule,
                                [],
                              ),
                              retreat_team: mergeRetreatTeam(
                                detail.retreat_team || row.retreat_team || [],
                              ),
                              subAdmins: row.subAdmins || [],
                              mission_statement:
                                detail.mission_statement ||
                                row.mission_statement ||
                                "",
                              description:
                                detail.description || row.description || "",
                              mail_msg: detail.mail_msg || row.mail_msg || "",
                            };
                            let data1 = new FormData();
                            data1.append("fromData", JSON.stringify(stateRef));
                            setApplyLoader(true);
                            retreatApi
                              .approveRetreat(data1)
                              .then((res) => {
                                if (res.success) {
                                  toast.success(res.msg);
                                  getAllTempRetreats();
                                } else {
                                  toast.error(res.msg);
                                }
                                setApplyLoader(false);
                              })
                              .catch((err) => {
                                toast.error(err.toString());
                                setApplyLoader(false);
                              });
                          }
                        }
                      }}
                    >
                      <i
                        className="mdi mdi-check-circle text-md text-success mx-2 font-size"
                        title="Approve"
                      ></i>
                    </button>
                  </>
                )}
                {/* <a
                  href={`/registration-retreat/${row.id}`}
                  className="font-size action-icons"
                  target="_blank"
                >
                  <i className="mdi mdi-eye" title="View"></i>
                </a> */}
              </>
            ),
            reorder: true,
            width: "200px",
          },
        ]
      : []),
    {
      id: "registrationLink",
      name: "Registration Link",
      button: true,
      cell: (row) => (
        <a
          href={`/registration-retreat/${row.id}?isTemp=true`}
          target="_blank"
          rel="noopener noreferrer"
          className="roasterKey"
        >
          <img
            src={row.image1 || uploadRetreat}
            className="column-rowImage"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = corruptedImg;
            }}
          />
        </a>
      ),
      reorder: true,
      width: "120px",
    },
    {
      id: "title",
      name: "Retreat Title",
      selector: (row) => {
        const formatDateRange = (from, to) => {
          if (moment(from).isSame(to, "day")) {
            return `${moment(from).tz("America/New_York").format("MMM D, YYYY")}`;
          } else if (moment(from).isSame(to, "month")) {
            return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to).tz("America/New_York").format("D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
          } else {
            return `${moment(from).tz("America/New_York").format("MMM D")} - ${moment(to).tz("America/New_York").format("MMM D")}, ${moment(from).tz("America/New_York").format("YYYY")}`;
          }
        };

        const displayDate =
          row.dateFrom && row.dateTo
            ? formatDateRange(row.dateFrom, row.dateTo)
            : null;

        return (
          <>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                navigate(`/retreatRoster?retreatId=${row.id}&isTemp=true`);
              }}
            >
              <div>
                {row?.parish}
                {row.language
                  ? ` (${row.language[0].toUpperCase()}${row.language.slice(1)}) `
                  : null}{" "}
                {row.location
                  ? `${row.location[0].toUpperCase()}${row.location.slice(1)}`
                  : ""}
              </div>
            </a>
            {displayDate && (
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip(displayDate)}
              >
                <span>{displayDate}</span>
              </OverlayTrigger>
            )}
          </>
        );
      },
      sortable: true,
      reorder: true,
      width: "300px",
    },

    {
      id: "language",
      name: "Language",
      selector: (row) =>
        row.language.charAt(0).toUpperCase() + row.language.slice(1),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.language.charAt(0).toUpperCase() + row.language.slice(1),
          )}
        >
          <span>
            {row.language.charAt(0).toUpperCase() + row.language.slice(1)}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "location",
      name: "Location",
      selector: (row) =>
        row.location.charAt(0).toUpperCase() + row.location.slice(1),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.location.charAt(0).toUpperCase() + row.location.slice(1),
          )}
        >
          <span>
            {row.location.charAt(0).toUpperCase() + row.location.slice(1)}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "fromToDate",
      name: "Retreat Dates",
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            row.dateFrom === row.dateTo
              ? moment(row && row.dateFrom)
                  .tz("America/New_York")
                  .format("MMM-DD-YYYY")
              : moment(row && row.dateFrom)
                  .tz("America/New_York")
                  .format("MMM DD") +
                  " - " +
                  moment(row && row.dateTo)
                    .tz("America/New_York")
                    .format("MMM DD") +
                  ", " +
                  moment(row && row.dateFrom)
                    .tz("America/New_York")
                    .format("YYYY"),
          )}
        >
          {row.dateFrom === row.dateTo ? (
            <span>
              {moment(row && row.dateFrom)
                .tz("America/New_York")
                .format("MMM-DD-YYYY")}
            </span>
          ) : (
            <span>
              {moment(row && row.dateFrom)
                .tz("America/New_York")
                .format("MMM-DD") +
                " - " +
                moment(row.dateTo).tz("America/New_York").format("MMM DD") +
                ", " +
                moment(row && row.dateFrom)
                  .tz("America/New_York")
                  .format("YYYY")}
            </span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "140px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "contact_name",
      name: "Contact Name",
      selector: (row) => row.contact_name,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.contact_name)}
        >
          <span>{row.contact_name}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "contact_name",
      name: "Contact Email",
      selector: (row) => row.contact_email,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.contact_email)}
        >
          <span>{row.contact_email}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
    {
      id: "contact_mobile",
      name: "Contact Mobile",
      selector: (row) => row.contact_mobile,
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(row.contact_mobile)}
        >
          <span>{row.contact_mobile}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },

    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      cell: (row) => (
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row && row.createdAt, "MM-DD-YYYY")}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
      sortable: true,
      width: "130px",
      style: {
        cursor: "text",
      },
    },
  ];

  const formattedDate = (date) => {
    return moment(date).tz("America/New_York").format("YYYY-MM-DD");
  };

  const getAllTempRetreats = async (
    pageNo = 1,
    size = 20,
    searchKeyword = null,
    sortBy = {},
    loadCount = false,
  ) => {
    setIsTempUpload1(false);
    setLoadData(true);
    let d = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else {
      d.searchKeyword = searchKey;
    }
    if (sortBy.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = false;
    if (userData?.access === true && userData?.userRole !== "ADMIN") {
      d.accessId = userData.id;
    }
    await retreatApi
      .getAllTempRetreats(d)
      .then((res) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setTotal(totalRecords);
          const parsedData = res.data.map((item) => {
            const { subAdmins, retreat_team, schedule, ...rest } = item;
            const parsedSchedule = schedule ? JSON.parse(schedule) : [];
            const parsedRetreat_team = retreat_team
              ? JSON.parse(retreat_team)
              : [];

            const parsedSubAdmins = subAdmins ? JSON.parse(subAdmins) : [];

            return {
              ...rest,
              schedule: parsedSchedule.map((entry) => ({
                date: new Date(entry.date),
                from: entry.from,
                to: entry.to,
              })),
              retreat_team: parsedRetreat_team,
              subAdmins: parsedSubAdmins,
            };
          });
          setLoadData(false);
          toast.success(res.msg);
          setTempRetreats(parsedData);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  const handleShow = (item) => {
    setTempRetreatDetail(item);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setTempRetreatDetail([]);
    getAllTempRetreats();
  };

  const SearchData = (event) => {
    const key = event.target.value;
    if (key !== "") {
      setSearchKey(event.target.value);
      getAllTempRetreats(1, 20, event.target.value);
    } else {
      setSearchKey("");
      getAllTempRetreats(1, 20, event.target.value);
    }
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const deleteTempRetreat = async () => {
    await retreatApi
      .deleteTempRetreat(tempRetreatDetail)
      .then(async (res) => {
        if (res.success) {
          handleClose();
          setShowREgModal(false);
          toast.success(res.msg);
          getAllTempRetreats();
        } else {
          handleClose();
          toast.error(res.msg);
          getAllTempRetreats();
          setShowREgModal(false);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const CloseCompose = () => {
    setValidated(false);
    setShowREgModal(false);
  };

  const handleChanges = (e) => {
    let { name, value } = e.target;
    let d = { ...data };
    if (e.target.name === "language") {
      const selectedLang = e.target.value;
      sampleContentApi.getSampleContent("Mission Statement", selectedLang).then(res => {
        if (res.success && res.data) {
          setMissionStatement(res.data.content);
          d.mission_statement = res.data.content.replace(/<[^>]*>/g, ''); // strip html for raw field if needed
          setData({...d});
        } else {
          // Fallback to hardcoded
          if (selectedLang === "spanish") {
            d.mission_statement = `"La misión de la Iglesia de Santa Monica y la del Ministerio de Matrimonios LOVESTRONG es el de apoyar, fortalecer y alimentar la unión centrada en Cristo, entre parejas casadas de nuestra Iglesia y Comunidad."`;
            setMissionStatement(
              `<p><em>"La misión de la Iglesia de Santa Monica y la del Ministerio de Matrimonios LOVESTRONG es el de apoyar, fortalecer y alimentar la unión centrada en Cristo, entre parejas casadas de nuestra Iglesia y Comunidad."</em></p>`,
            );
          } else {
            d.mission_statement = `"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."`;
            setMissionStatement(
              `<p><em>"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."</em></p>`,
            );
          }
          setData({...d});
        }
      });
      
      loadDescriptionAndEmailSamples(selectedLang);

      i18n.changeLanguage(selectedLang);
    }
    if (name == "image1") {
      const file = e.target.files[0];
      if (file) {
        processRetreatImage(file)
          .then((processedFile) => {
            d.image1 = processedFile;
            toast.success("The retreat image has been successfully added.");
            setData({ ...d });
          })
          .catch((error) => {
            toast.error(error.message);
            e.target.value = "";
          });
      }
      return;
    } else {
      d[name] = value;
    }
    if (name === "contact_email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({
          ...prev,
          [name]: t("invalid_email_format"),
        }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
    setData(d);
  };

  const upload = () => {
    document.getElementById("retreatImageUpload").click();
  };

  const remove = () => {
    let d = { ...data };
    d.image1 = "";
    setData(d);
    setIsTempUpload1(false);
  };

  const handleTimeChange = (name, value, index) => {
    const newData = { ...data };
    if (!Array.isArray(newData.schedule)) {
      newData.schedule = [];
    }

    // Ensure the schedule array has an entry at the specified index
    if (!newData.schedule[index]) {
      newData.schedule[index] = {};
    }

    if (name.includes("date")) {
      const isValid = value && moment(value).isValid();
      if (isValid) {
        // Adjust the date for the specified timezone
        const adjustedDate = moment(value)
          .tz("America/New_York", true)
          .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        // Set the date property for the schedule entry at the given index
        newData.schedule[index].date = adjustedDate;

        // Auto-fill other dates
        if (index === 0) {
          // Friday selected, set Saturday and Sunday
          const satDate = moment(value).add(1, "days");
          const sunDate = moment(value).add(2, "days");
          if (!newData.schedule[1]) newData.schedule[1] = {};
          if (!newData.schedule[2]) newData.schedule[2] = {};
          newData.schedule[1].date = satDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[2].date = sunDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        } else if (index === 1) {
          // Saturday selected, set Friday and Sunday
          const friDate = moment(value).subtract(1, "days");
          const sunDate = moment(value).add(1, "days");
          if (!newData.schedule[0]) newData.schedule[0] = {};
          if (!newData.schedule[2]) newData.schedule[2] = {};
          newData.schedule[0].date = friDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[2].date = sunDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        } else if (index === 2) {
          // Sunday selected, set Friday and Saturday
          const friDate = moment(value).subtract(2, "days");
          const satDate = moment(value).subtract(1, "days");
          if (!newData.schedule[0]) newData.schedule[0] = {};
          if (!newData.schedule[1]) newData.schedule[1] = {};
          newData.schedule[0].date = friDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[1].date = satDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        }
      } else {
        newData.schedule[index].date = "";
        if (index === 0) {
          if (newData.schedule[1]) newData.schedule[1].date = "";
          if (newData.schedule[2]) newData.schedule[2].date = "";
        } else if (index === 1) {
          if (newData.schedule[0]) newData.schedule[0].date = "";
          if (newData.schedule[2]) newData.schedule[2].date = "";
        } else if (index === 2) {
          if (newData.schedule[0]) newData.schedule[0].date = "";
          if (newData.schedule[1]) newData.schedule[1].date = "";
        }
      }

      // Update day name based on the adjusted date and language
      newData.schedule.forEach((item) => {
        if (item.date && moment(item.date).isValid()) {
          item.dayName = getDayName(item.date, newData.language);
        } else {
          item.dayName = "";
        }
      });
    } else if (name.includes("from")) {
      // Check if "From" and "To" times are the same
      if (newData.schedule[index].to && newData.schedule[index].to === value) {
        setCheck(`${index}`);
      } else {
        setCheck("");
        newData.schedule[index].from = value;
      }
    } else if (name.includes("to")) {
      // Check if "To" and "From" times are the same
      if (
        newData.schedule[index].from &&
        newData.schedule[index].from === value
      ) {
        setCheck(`${index}`);
      } else {
        setCheck("");
        newData.schedule[index].to = value;
      }
    }

    setData(newData);
  };

  function getDayName(dateString, language) {
    const dateInUSTimezone = moment(dateString).tz("America/New_York");
    let days = [];
    if (language === "spanish") {
      days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
    } else {
      days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
    }
    return days[dateInUSTimezone.day()];
  }

  const handleRetreatTeam = (e, couple) => {
    const { name, value } = e.target;
    setData((prevData) => {
      const retreat_team = prevData.retreat_team || [];
      const roleExists = retreat_team.some((member) => member.role === couple);

      let updatedTeam;
      if (roleExists) {
        updatedTeam = retreat_team.map((member) =>
          member.role === couple ? { ...member, [name]: value } : member,
        );
      } else {
        updatedTeam = [...retreat_team, { role: couple, [name]: value }];
      }

      return {
        ...prevData,
        retreat_team: updatedTeam,
      };
    });

    if (name === "hisEmail" || name === "herEmail" || name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const errorKey = `${couple}_${name}`;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({
          ...prev,
          [errorKey]: t("invalid_email_format"),
        }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [errorKey]: "" }));
      }
    }
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    const hasErrors = Object.values(emailErrors).some((error) => error !== "");
    if (hasErrors) {
      toast.error(t("vaild_email_address"));
      return;
    }

    if (form.checkValidity()) {
      setIsTempUpload1(false);
      setApplyLoader(true);
      let data1 = new FormData();
      if (data && data.image1 && data.image1.name) {
        data1.append("file1", data.image1);
        delete data.image1;
      }
      let stateRef = { ...data };
      stateRef.mission_statement = missionStatement;
      stateRef.description = description;
      stateRef.mail_msg = emailMsg;
      if (stateRef.schedule && stateRef.schedule.length) {
        data1.append("fromData", JSON.stringify(stateRef));

        const apiCall =
          userData && userData.userRole === "ADMIN" && isApproveAction
            ? retreatApi.approveRetreat(data1)
            : retreatApi.updateTempRetreat(data1);

        apiCall
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              getAllTempRetreats();
              setApplyLoader(false);
              setShowREgModal(false);
            } else {
              setApplyLoader(false);
              toast.error(res.msg);
              setShowREgModal(false);
            }
          })
          .catch((error) => {
            setApplyLoader(false);
            toast.error(error);
          });
      } else {
        toast.error("Atleast one time schedule is required!");
      }
    }
    setValidated(true);
  };

  function formatLabel(firstName, lastName, email) {
    let namePart = "";
    if (lastName) {
      namePart += lastName;
    }

    if (firstName) {
      namePart += (lastName ? ", " : "") + firstName;
    }

    return namePart ? `${namePart} - ${email}` : email;
  }

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then(async (res) => {
        if (res.success) {
          let allMailcoupleList = [];
          res.data && setFullCouples(res.data);
          res.data &&
            res.data.forEach((item) => {
              if (item.hisEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.hisFirstName,
                    item.hisLastName,
                    item.hisEmail,
                  ),
                  value: item.id,
                });
              }

              if (item.herEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.herFirstName,
                    item.herLastName,
                    item.herEmail,
                  ),
                  value: item.id,
                });
              }
            });
          await adminApi.outerUsers().then((outerRes) => {
            if (outerRes.success) {
              outerRes.data &&
                outerRes.data.forEach((item) => {
                  if (item.email) {
                    allMailcoupleList.push({
                      label: item.email,
                      value: item.id,
                    });
                  }
                });
              setAllCoupleMails(allMailcoupleList);
            }
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getAllPriests = async () => {
    await priestApi
      .getAllPriests()
      .then((res) => {
        if (res.success) {
          setFullPriests(res.data);
        }
      })
      .catch((err) => {
        toast.error(err.toString());
      });
  };

  const handleSelectExistingCouple = (selectedOption, role) => {
    if (!selectedOption) {
      setData((prevData) => {
        const updatedTeam = prevData.retreat_team.map((member) =>
          member.role === role
            ? {
                ...member,
                hisFirstName: "",
                hisLastName: "",
                hisEmail: "",
                herFirstName: "",
                herLastName: "",
                herEmail: "",
              }
            : member,
        );
        return {
          ...prevData,
          retreat_team: updatedTeam,
        };
      });
      return;
    }
    const coupleData = fullCouples.find((c) => c.id === selectedOption.value);
    if (coupleData) {
      setData((prevData) => {
        const retreat_team = prevData.retreat_team || [];
        const roleExists = retreat_team.some((member) => member.role === role);

        let updatedTeam;
        const newMemberData = {
          role: role,
          hisFirstName: coupleData.hisFirstName || "",
          hisLastName: coupleData.hisLastName || "",
          hisEmail: coupleData.hisEmail || "",
          herFirstName: coupleData.herFirstName || "",
          herLastName: coupleData.herLastName || "",
          herEmail: coupleData.herEmail || "",
        };

        if (roleExists) {
          updatedTeam = retreat_team.map((member) =>
            member.role === role ? { ...member, ...newMemberData } : member,
          );
        } else {
          updatedTeam = [...retreat_team, newMemberData];
        }

        return {
          ...prevData,
          retreat_team: updatedTeam,
        };
      });
    }
  };

  const handleSelectExistingPriest = (
    selectedOption,
    directPriestData = null,
  ) => {
    if (!selectedOption) {
      setSelectedPriestOption(null);
      setData((prevData) => {
        const updatedTeam = prevData.retreat_team.map((member) =>
          member.role === "spiritual_director"
            ? {
                ...member,
                firstName: "",
                lastName: "",
                email: "",
              }
            : member,
        );
        return {
          ...prevData,
          retreat_team: updatedTeam,
          priestId: null,
        };
      });
      return;
    }

    setSelectedPriestOption(selectedOption);

    const priestData =
      directPriestData ||
      fullPriests.find((p) => p.id === selectedOption.value);
    if (priestData) {
      setData((prevData) => {
        const updatedTeam = prevData.retreat_team.map((member) =>
          member.role === "spiritual_director"
            ? {
                ...member,
                firstName: priestData.firstName || "",
                lastName: priestData.lastName || priestData.name || "",
                email: priestData.email || "",
              }
            : member,
        );
        return {
          ...prevData,
          retreat_team: updatedTeam,
          priestId: priestData.id,
        };
      });
    }
  };

  const handleAddPriestClick = async () => {
    setEdiUserIdClicked("");
    setPriestData({
      id: "",
      primaryKey: "",
      parishId: null,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      city: "",
      state: "",
      zip: "",
      imageUrl: "",
      address: "",
    });
    await priestApi
      .checkPKPriest()
      .then((res) => {
        if (res.success) {
          const nextPk = res.data || "P101";
          setAlreadyPk(nextPk);
          setPriestData((prev) => ({ ...prev, primaryKey: nextPk }));
          setShowPriestModal(true);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const handlePriestSuccess = (newPriest) => {
    if (newPriest) {
      setFullPriests((prev) => [...prev, newPriest]);
      const label = `${newPriest.title ? newPriest.title + " " : ""}${newPriest.firstName} ${newPriest.lastName || newPriest.name}`;
      handleSelectExistingPriest(
        {
          label: label,
          value: newPriest.id,
        },
        newPriest,
      );
    }
  };

  const coupleOptions = fullCouples.map((item) => ({
    label: formatCoupleOptionLabel(item),
    value: item.id,
  }));

  const priestOptions = fullPriests.map((item) => ({
    label: `${item.title ? item.title + " " : ""}${item.firstName} ${item.lastName || item.name} - ${item.email}`,
    value: item.id,
  }));

  const handleSelectOption = (val) => {
    setCoupleSelectForAccess(val);
  };

  const handleAccessSubmit = async () => {
    if (coupleSelectForAccess && coupleSelectForAccess.length) {
      const submitData = coupleSelectForAccess.map((option) => ({
        label: option.label,
        value: option.value,
      }));
      setAccessGreenTick(true);
      setData((prev) => {
        const existing = prev.subAdmins || [];
        const merged = [
          ...existing,
          ...submitData.filter(
            (newItem) => !existing.some((ex) => ex.value === newItem.value),
          ),
        ];
        return {
          ...prev,
          subAdmins: merged,
        };
      });
      setCoupleSelectForAccess([]);
      setTimeout(() => {
        setAccessGreenTick(false);
      }, 2000);
    } else {
      toast.error("Please select or create at least one sub-admin.");
    }
  };

  const handlerAccessRmvShow = (item) => {
    setData((prev) => ({
      ...prev,
      subAdmins: prev.subAdmins.filter((c) => c.value !== item.value),
    }));
  };

  const renderModel = () => {
    return (
      <div className="tab_headers">
        <Modal
          show={showRegModal}
          onHide={() => {
            CloseCompose();
          }}
          size="lg"
        >
          <Modal.Header
            closeButton={() => {
              CloseCompose();
            }}
            className="pb-5 px-4 px-sm-5"
          >
            <h4> {t("register_new_retreat")}</h4>
          </Modal.Header>
          <div className="row w-100 mx-0">
            <div className="col-lg-12 mx-auto">
              <div className="auth-form-light text-left main-register pb-5 px-4 px-sm-5">
                <Form
                  onSubmit={handleSubmit}
                  noValidate
                  validated={validated}
                  className="forms-sample"
                >
                  <Row>
                    <Col lg={6} md={6} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("enter_Parish_name")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Select
                          required
                          size="sm"
                          type="text"
                          name="parishId"
                          id="parishId"
                          placeholder="Parish"
                          value={data.parishId}
                          className="language-selection"
                          onChange={(e) => handleChanges(e)}
                        >
                          <option value="" className="dark-option">
                            {t("select_parish")}
                          </option>
                          {parishList
                            .filter(
                              (item) =>
                                item.parishCategoryName?.toUpperCase() !==
                                "OTHER",
                            )
                            .map((item) => {
                              return (
                                <option
                                  key={`parish-${item.id}`}
                                  className="dark-option"
                                  value={item.id}
                                >
                                  {formatParishOptionLabel(item)}
                                </option>
                              );
                            })}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {t("parish_required")}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6} md={6} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("select_retreat_language")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          required
                          size="sm"
                          type="text"
                          name="language"
                          id="language"
                          placeholder="Language"
                          value={data.language}
                          onChange={(e) => handleChanges(e)}
                        >
                          <option value="">{t("select")}</option>
                          <option value="english">English</option>
                          <option value="spanish">Spanish</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {t("language_required")}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6} md={6} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("enter_location")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          size="sm"
                          type="text"
                          name="location"
                          id="location"
                          placeholder="Location"
                          value={data.location}
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("location_required")}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="form-group">
                        <Form.Label>{t("retreat_theme")}</Form.Label>
                        <Form.Control
                          // required
                          size="sm"
                          type="text"
                          name="heading"
                          id="heading"
                          placeholder={t("retreat_theme")}
                          value={data.heading}
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("retreat_theme_required")}
                        </Form.Control.Feedback>
                      </Form.Group>


                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("retreat_payment_link")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          size="sm"
                          type="text"
                          name="paymentLink"
                          id="paymentLink"
                          placeholder="Retreat Payment Link"
                          value={data.paymentLink}
                          onChange={(e) => handleChanges(e)}
                          // readOnly={isEditAdmin}
                        />
                        <Form.Control.Feedback type="invalid">
                          Payment link is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6} md={6} xs={12}>
                      <Form.Group>
                        {data.image1 == "" || data.image1 == undefined ? (
                          <div className="edit-profile-img mb-2 text-center">
                            <img src={uploadRetreat} />
                          </div>
                        ) : (
                          <div className="edit-profile-img mb-2 text-center">
                            <img
                              src={getRetreatImagePreviewSrc(data?.image1)}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = corruptedImg;
                              }}
                            />
                          </div>
                        )}{" "}
                        <div className="text-center mt-3">
                          {data.image1 == "" || data.image1 == undefined ? (
                            <>
                              <input
                                name="image1"
                                className="pt-1"
                                type="file"
                                accept={RETREAT_IMAGE_ACCEPT}
                                style={{ display: "none" }}
                                id="retreatImageUpload"
                                onChange={(e) => handleChanges(e)}
                              />
                              <span className="d-inline-flex align-items-center justify-content-center">
                                <Button
                                  variant="primary"
                                  className="mb-1 text-center"
                                  onClick={(e) => {
                                    upload();
                                  }}
                                >
                                  {t("upload_retreat_image")}
                                </Button>
                                <RetreatImageUploadInfo />
                              </span>
                            </>
                          ) : (
                            <Button
                              variant="danger"
                              className="mb-1 mt-2 "
                              onClick={(e) => {
                                remove();
                              }}
                            >
                              {t("remove")}
                            </Button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
            <hr />
                    <Col lg={12} md={12} xs={12} className="mt-3">
                      <Row>
                        <Col lg={2} md={2} xs={2} className="mt-4">
                          <h4>{t("friday")}</h4>
                        </Col>

                        <Col lg={4} md={4} xs={12}>
                          {" "}
                          <div>
                            <div>
                              {" "}
                              <Form.Label>
                                {t("date")}
                                <span className="text-danger">*</span>
                              </Form.Label>
                            </div>
                            <DatePicker
                              autoComplete="off"
                              id="dateId"
                              dateFormat="MM-dd-yyyy"
                              placeholderText="mm-dd-yyyy"
                              className="form-select"
                              selected={
                                (() => {
                                  const dStr = data?.schedule?.[0]?.date;
                                  if (!dStr || dStr === "Invalid date") return null;
                                  const m = moment(formattedDate(dStr));
                                  return m.isValid() ? m.toDate() : null;
                                })()
                              }
                              name="date0"
                              onChange={(date) =>
                                handleTimeChange("date0", date, 0)
                              }
                              filterDate={(date) => date.getDay() === 5} // 5 represents Friday
                              renderCustomHeader={({
                                date,
                                changeYear,
                                changeMonth,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => {
                                const years = Array.from(
                                  { length: 100 },
                                  (_, i) => new Date().getFullYear() - i,
                                );
                                const months = [
                                  "January",
                                  "February",
                                  "March",
                                  "April",
                                  "May",
                                  "June",
                                  "July",
                                  "August",
                                  "September",
                                  "October",
                                  "November",
                                  "December",
                                ];

                                return (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      paddingBottom: "8px",
                                    }}
                                  >
                                    {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                    <div
                                      style={{
                                        marginBottom: "10px",
                                        display: "flex",
                                        gap: "10px",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {/* Month Dropdown */}
                                      <select
                                        style={{
                                          fontSize: "16px",
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                        }}
                                        value={months[date.getMonth()]}
                                        onChange={({ target: { value } }) =>
                                          changeMonth(months.indexOf(value))
                                        }
                                      >
                                        {months.map((month) => (
                                          <option key={month} value={month}>
                                            {month}
                                          </option>
                                        ))}
                                      </select>

                                      {/* Year Dropdown */}
                                      <select
                                        style={{
                                          fontSize: "16px",
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                        }}
                                        value={date.getFullYear()}
                                        onChange={({ target: { value } }) =>
                                          changeYear(value)
                                        }
                                      >
                                        {years.map((year) => (
                                          <option key={year} value={year}>
                                            {year}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    {/* ✅ Optional month navigation below */}
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <button
                                        onClick={decreaseMonth}
                                        disabled={prevMonthButtonDisabled}
                                        style={{
                                          fontSize: "18px",
                                          padding: "2px 8px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {"<"}
                                      </button>

                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "16px",
                                        }}
                                      >
                                        {months[date.getMonth()]}{" "}
                                        {date.getFullYear()}
                                      </span>

                                      <button
                                        onClick={increaseMonth}
                                        disabled={nextMonthButtonDisabled}
                                        style={{
                                          fontSize: "18px",
                                          padding: "2px 8px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {">"}
                                      </button>
                                    </div>
                                  </div>
                                );
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              {t("date_required")}
                            </Form.Control.Feedback>
                          </div>
                        </Col>

                        <Col lg={3} md={3} xs={5} className="timeData">
                          {" "}
                          <Form.Group className="form-group">
                            <Form.Label>{t("from")}</Form.Label>
                            <TimePicker
                              chekPicker={Pass}
                              useTwelveHourFormat={true}
                              showClockIcon={false}
                              showCloseIcon={true}
                              allowBackdrop={true}
                              onTimeChange={(time) =>
                                handleTimeChange("from0", time, 0)
                              }
                              placeholder="00 : 00 am"
                              defaulValue="00 : 00"
                              value={data?.schedule?.[0]?.from}
                              className="timePicker"
                            />
                            <Form.Control.Feedback type="invalid">
                              {t("time_from_required")}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col lg={3} md={3} xs={5} className="timeData">
                          {" "}
                          <Form.Group className="form-group">
                            <Form.Label>{t("to")}</Form.Label>
                            <TimePicker
                              chekPicker={Pass}
                              useTwelveHourFormat={true}
                              showClockIcon={false}
                              showCloseIcon={true}
                              allowBackdrop={true}
                              onTimeChange={(time) =>
                                handleTimeChange("to0", time, 0)
                              }
                              value={data?.schedule?.[0]?.to}
                              placeholder="00 : 00 am"
                              defaulValue="00 : 00"
                              className="timePicker indexVlues"
                            />{" "}
                            <Form.Control.Feedback type="invalid">
                              {t("time_to_required")}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12} md={12} xs={12} className="mb-3 text-center">
                      {" "}
                      {check && check === "0" ? (
                        <h5 className="text-danger mt-2">{t("time_error")}</h5>
                      ) : null}
                    </Col>
                    <Col lg={12} md={12} xs={12} className="mt-3">
                      <Row>
                        <Col lg={2} md={2} xs={2} className="mt-4">
                          <h4>{t("saturday")}</h4>
                        </Col>

                        <Col lg={4} md={4} xs={12}>
                          {" "}
                          <div>
                            <div>
                              {" "}
                              <Form.Label>
                                Date
                                <span className="text-danger">*</span>
                              </Form.Label>
                            </div>
                            <DatePicker
                              autoComplete="off"
                              id="dateId"
                              dateFormat="MM-dd-yyyy"
                              placeholderText="mm-dd-yyyy"
                              className="form-select"
                              selected={
                                (() => {
                                  const dStr = data?.schedule?.[1]?.date;
                                  if (!dStr || dStr === "Invalid date") return null;
                                  const m = moment(formattedDate(dStr));
                                  return m.isValid() ? m.toDate() : null;
                                })()
                              }
                              name="date1"
                              onChange={(date) =>
                                handleTimeChange("date1", date, 1)
                              }
                              filterDate={(date) => date.getDay() === 6}
                              renderCustomHeader={({
                                date,
                                changeYear,
                                changeMonth,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => {
                                const years = Array.from(
                                  { length: 100 },
                                  (_, i) => new Date().getFullYear() - i,
                                );
                                const months = [
                                  "January",
                                  "February",
                                  "March",
                                  "April",
                                  "May",
                                  "June",
                                  "July",
                                  "August",
                                  "September",
                                  "October",
                                  "November",
                                  "December",
                                ];

                                return (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      paddingBottom: "8px",
                                    }}
                                  >
                                    {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                    <div
                                      style={{
                                        marginBottom: "10px",
                                        display: "flex",
                                        gap: "10px",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {/* Month Dropdown */}
                                      <select
                                        style={{
                                          fontSize: "16px",
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                        }}
                                        value={months[date.getMonth()]}
                                        onChange={({ target: { value } }) =>
                                          changeMonth(months.indexOf(value))
                                        }
                                      >
                                        {months.map((month) => (
                                          <option key={month} value={month}>
                                            {month}
                                          </option>
                                        ))}
                                      </select>

                                      {/* Year Dropdown */}
                                      <select
                                        style={{
                                          fontSize: "16px",
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                        }}
                                        value={date.getFullYear()}
                                        onChange={({ target: { value } }) =>
                                          changeYear(value)
                                        }
                                      >
                                        {years.map((year) => (
                                          <option key={year} value={year}>
                                            {year}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    {/* ✅ Optional month navigation below */}
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <button
                                        onClick={decreaseMonth}
                                        disabled={prevMonthButtonDisabled}
                                        style={{
                                          fontSize: "18px",
                                          padding: "2px 8px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {"<"}
                                      </button>

                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "16px",
                                        }}
                                      >
                                        {months[date.getMonth()]}{" "}
                                        {date.getFullYear()}
                                      </span>

                                      <button
                                        onClick={increaseMonth}
                                        disabled={nextMonthButtonDisabled}
                                        style={{
                                          fontSize: "18px",
                                          padding: "2px 8px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {">"}
                                      </button>
                                    </div>
                                  </div>
                                );
                              }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Atleast one date is required!
                            </Form.Control.Feedback>
                          </div>
                        </Col>

                        <Col lg={3} md={3} xs={5} className="timeData">
                          {" "}
                          <Form.Group className="form-group">
                            <Form.Label>{t("from")}</Form.Label>
                            <TimePicker
                              chekPicker={Pass}
                              useTwelveHourFormat={true}
                              showClockIcon={false}
                              showCloseIcon={true}
                              allowBackdrop={true}
                              onTimeChange={(time) =>
                                handleTimeChange("from1", time, 1)
                              }
                              placeholder="00 : 00 am"
                              defaulValue="00 : 00"
                              value={data && data?.schedule?.[1]?.from}
                              className="timePicker"
                            />
                            <Form.Control.Feedback type="invalid">
                              Time From is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col lg={3} md={3} xs={5} className="timeData">
                          {" "}
                          <Form.Group className="form-group">
                            <Form.Label>{t("to")}</Form.Label>
                            <TimePicker
                              chekPicker={Pass}
                              useTwelveHourFormat={true}
                              showClockIcon={false}
                              showCloseIcon={true}
                              allowBackdrop={true}
                              onTimeChange={(time) =>
                                handleTimeChange("to1", time, 1)
                              }
                              placeholder="00 : 00 am"
                              defaulValue="00 : 00"
                              value={data?.schedule?.[1]?.to}
                              className="timePicker indexVlues"
                            />{" "}
                            <Form.Control.Feedback type="invalid">
                              Time To is required!
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12} md={12} xs={12} className="mb-3 text-center">
                      {" "}
                      {check && check === "1" ? (
                        <h5 className="text-danger mt-2">{t("time_error")}</h5>
                      ) : null}
                    </Col>

                    <Col lg={12} md={12} xs={12} className="mt-3">
                      <Row>
                        <Col lg={2} md={2} xs={2} className="mt-4">
                          <h4>{t("sunday")}</h4>
                        </Col>
                        <Col lg={4} md={4} xs={12}>
                          {" "}
                          <div>
                            <div>
                              {" "}
                              <Form.Label>
                                Date
                                <span className="text-danger">*</span>
                              </Form.Label>
                            </div>
                            <DatePicker
                              autoComplete="off"
                              id="dateId"
                              dateFormat="MM-dd-yyyy"
                              placeholderText="mm-dd-yyyy"
                              className="form-select"
                              selected={
                                (() => {
                                  const dStr = data?.schedule?.[2]?.date;
                                  if (!dStr || dStr === "Invalid date") return null;
                                  const m = moment(formattedDate(dStr));
                                  return m.isValid() ? m.toDate() : null;
                                })()
                              }
                              name="date2"
                              onChange={(date) =>
                                handleTimeChange("date2", date, 2)
                              }
                              filterDate={(date) => date.getDay() === 0}
                              renderCustomHeader={({
                                date,
                                changeYear,
                                changeMonth,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => {
                                const years = Array.from(
                                  { length: 100 },
                                  (_, i) => new Date().getFullYear() - i,
                                );
                                const months = [
                                  "January",
                                  "February",
                                  "March",
                                  "April",
                                  "May",
                                  "June",
                                  "July",
                                  "August",
                                  "September",
                                  "October",
                                  "November",
                                  "December",
                                ];

                                return (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      paddingBottom: "8px",
                                    }}
                                  >
                                    {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                    <div
                                      style={{
                                        marginBottom: "10px",
                                        display: "flex",
                                        gap: "10px",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {/* Month Dropdown */}
                                      <select
                                        style={{
                                          fontSize: "16px",
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                        }}
                                        value={months[date.getMonth()]}
                                        onChange={({ target: { value } }) =>
                                          changeMonth(months.indexOf(value))
                                        }
                                      >
                                        {months.map((month) => (
                                          <option key={month} value={month}>
                                            {month}
                                          </option>
                                        ))}
                                      </select>

                                      {/* Year Dropdown */}
                                      <select
                                        style={{
                                          fontSize: "16px",
                                          padding: "6px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ccc",
                                        }}
                                        value={date.getFullYear()}
                                        onChange={({ target: { value } }) =>
                                          changeYear(value)
                                        }
                                      >
                                        {years.map((year) => (
                                          <option key={year} value={year}>
                                            {year}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    {/* ✅ Optional month navigation below */}
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                    >
                                      <button
                                        onClick={decreaseMonth}
                                        disabled={prevMonthButtonDisabled}
                                        style={{
                                          fontSize: "18px",
                                          padding: "2px 8px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {"<"}
                                      </button>

                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "16px",
                                        }}
                                      >
                                        {months[date.getMonth()]}{" "}
                                        {date.getFullYear()}
                                      </span>

                                      <button
                                        onClick={increaseMonth}
                                        disabled={nextMonthButtonDisabled}
                                        style={{
                                          fontSize: "18px",
                                          padding: "2px 8px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {">"}
                                      </button>
                                    </div>
                                  </div>
                                );
                              }}
                            />
                            <Form.Control.Feedback type="invalid">
                              {t("date_required")}
                            </Form.Control.Feedback>
                          </div>
                        </Col>

                        <Col lg={3} md={3} xs={5} className="timeData">
                          {" "}
                          <Form.Group className="form-group">
                            <Form.Label>{t("from")}</Form.Label>
                            <TimePicker
                              chekPicker={Pass}
                              useTwelveHourFormat={true}
                              showClockIcon={false}
                              showCloseIcon={true}
                              allowBackdrop={true}
                              onTimeChange={(time) =>
                                handleTimeChange("from2", time, 2)
                              }
                              placeholder="00 : 00 am"
                              defaulValue="00 : 00"
                              value={data && data?.schedule?.[2]?.from}
                              className="timePicker"
                            />
                            <Form.Control.Feedback type="invalid">
                              {t("time_from_required")}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <Col lg={3} md={3} xs={5} className="timeData">
                          {" "}
                          <Form.Group className="form-group">
                            <Form.Label>{t("to")}</Form.Label>
                            <TimePicker
                              chekPicker={Pass}
                              useTwelveHourFormat={true}
                              showClockIcon={false}
                              showCloseIcon={true}
                              allowBackdrop={true}
                              onTimeChange={(time) =>
                                handleTimeChange("to2", time, 2)
                              }
                              placeholder="00 : 00 am"
                              defaulValue="00 : 00"
                              value={data?.schedule?.[2]?.to}
                              className="timePicker indexVlues"
                            />{" "}
                            <Form.Control.Feedback type="invalid">
                              {t("time_to_required")}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12} md={12} xs={12} className="mb-3 text-center">
                      {" "}
                      {check && check === "2" ? (
                        <h5 className="text-danger mt-2">{t("time_error")}</h5>
                      ) : null}
                    </Col>
                    {/* <Col lg={12} md={12} xs={12}>
                      <Form.Group
                        className="form-group col-12"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>Mission Statement</Form.Label>
                        <SunEditor
                          id="outlined-adornment-quote"
                          // autoFocus={false}
                          type="text"
                          onChange={(e) => setMissionStatement(e)}
                          setContents={missionStatement}
                          name="mission_statement"
                          inputProps={{}}
                          setOptions={{
                            buttonList: [
                              [
                                "undo",
                                "redo",
                                "font",
                                "fontSize",
                                "formatBlock",
                              ],
                              ["bold", "underline", "italic", "removeFormat"],
                              [
                                "fontColor",
                                "hiliteColor",
                                "outdent",
                                "indent",
                                "align",
                                "horizontalRule",
                                "list",
                              ],
                              ["fullScreen", "link", "save"],
                            ],
                          }}
                        />

                        <Form.Control.Feedback type="invalid">
                          Mission Statement is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    <Col lg={12} md={12} xs={12}>
                      {" "}
                      <Form.Group
                        className="form-group col-12"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>{t("description")}</Form.Label>
                        <h5
                          onClick={() => {
                            loadDescriptionAndEmailSamples(data?.language);
                            setDescriptionSample(true);
                          }}
                          className="btn sampleData"
                        >
                          {t("description_sample")}
                        </h5>
                        <SunEditor
                          id="outlined-adornment-quote"
                          type="text"
                          height="250px"
                          onChange={(e) => setDescription(e)}
                          setContents={description}
                          name="description"
                          inputProps={{}}
                          setOptions={{
                            buttonList: [
                              [
                                "undo",
                                "redo",
                                "font",
                                "fontSize",
                                "formatBlock",
                              ],
                              ["bold", "underline", "italic", "removeFormat"],
                              [
                                "fontColor",
                                "hiliteColor",
                                "outdent",
                                "indent",
                                "align",
                                "horizontalRule",
                                "list",
                              ],
                              ["fullScreen", "link", "save"],
                            ],
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Description is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={12} md={12} xs={12}>
                      <Form.Group
                        className="form-group col-12"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>{t("email_message")}</Form.Label>

                        <h5
                          onClick={() => setMailMsgView(true)}
                          className="btn sampleData"
                        >
                          {t("email_preview")}
                        </h5>
                        <h5
                          onClick={() => {
                            loadDescriptionAndEmailSamples(data?.language);
                            setMailSample(true);
                          }}
                          className="btn sampleData"
                        >
                          {t("sample_email_message")}
                        </h5>

                        <SunEditor
                          id="outlined-adornment-quote"
                          type="text"
                          height="250px"
                          onChange={(e) => setEmailMsg(e)}
                          setContents={emailMsg}
                          name="mail_msg"
                          inputProps={{}}
                          setOptions={{
                            buttonList: [
                              [
                                "undo",
                                "redo",
                                "font",
                                "fontSize",
                                "formatBlock",
                              ],
                              ["bold", "underline", "italic", "removeFormat"],
                              [
                                "fontColor",
                                "hiliteColor",
                                "outdent",
                                "indent",
                                "align",
                                "horizontalRule",
                                "list",
                              ],
                              ["fullScreen", "link", "save"],
                            ],
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Email message is required!
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={12} md={12} xs={12} className="mb-3">
                      <h3> {t("retreat_team")}</h3>
                    </Col>
                    <Col lg={4} md={4} xs={12} className="border-right">
                      <h4>{t("lead_couple")}</h4>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("select_existing_couple")}</Form.Label>
                          <Select
                            options={coupleOptions}
                            onChange={(opt) =>
                              handleSelectExistingCouple(opt, "lead_couple")
                            }
                            placeholder={t("select")}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_first_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisFirstName"
                            id="hisFirstName"
                            placeholder={t("his_first_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.hisFirstName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "lead_couple")
                            }
                            // readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_first_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_last_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisLastName"
                            id="hisLastName"
                            placeholder={t("his_last_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.hisLastName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_last_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_email")}</Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="hisEmail"
                            id="hisEmail"
                            placeholder={t("email")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.hisEmail) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_email_required")}
                          </Form.Control.Feedback>
                          {emailErrors.lead_couple_hisEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.lead_couple_hisEmail}
                            </span>
                          )}
                        </Form.Group>
                      </Col>

                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_first_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herFirstName"
                            id="herFirstName"
                            placeholder={t("her_first_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.herFirstName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_first_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_last_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herLastName"
                            id="herLastName"
                            placeholder={t("her_last_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.herLastName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_last_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_email")}</Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="herEmail"
                            id="herEmail"
                            placeholder="Email"
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "lead_couple",
                                )?.herEmail) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_email_required")}
                          </Form.Control.Feedback>
                          {emailErrors.lead_couple_herEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.lead_couple_herEmail}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Col>

                    <Col lg={4} md={4} xs={12} className="border-right">
                      <h4>{t("co_lead_couple")}</h4>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("select_existing_couple")}</Form.Label>
                          <Select
                            options={coupleOptions}
                            onChange={(opt) =>
                              handleSelectExistingCouple(opt, "co_lead_couple")
                            }
                            placeholder={t("select")}
                            isClearable={true}
                            isSearchable={true}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_first_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisFirstName"
                            id="hisFirstName"
                            placeholder={t("his_first_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.hisFirstName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "co_lead_couple")
                            }
                            // readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_first_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_last_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisLastName"
                            id="hisLastName"
                            placeholder={t("his_last_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.hisLastName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "co_lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_last_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_email")}</Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="hisEmail"
                            id="hisEmail"
                            placeholder="Email"
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.hisEmail) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "co_lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_email_required")}
                          </Form.Control.Feedback>
                          {emailErrors.co_lead_couple_hisEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.co_lead_couple_hisEmail}
                            </span>
                          )}
                        </Form.Group>
                      </Col>

                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_first_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herFirstName"
                            id="herFirstName"
                            placeholder={t("her_first_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.herFirstName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "co_lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_first_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_last_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herLastName"
                            id="herLastName"
                            placeholder={t("her_last_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.herLastName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "co_lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_last_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_email")}</Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="herEmail"
                            id="herEmail"
                            placeholder="Email"
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "co_lead_couple",
                                )?.herEmail) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "co_lead_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_email_required")}
                          </Form.Control.Feedback>
                          {emailErrors.co_lead_couple_herEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.co_lead_couple_herEmail}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Col>

                    <Col lg={4} md={4} xs={12}>
                      <h4>{t("mentor_couple")}</h4>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("select_existing_couple")}</Form.Label>
                          <Select
                            options={coupleOptions}
                            onChange={(opt) =>
                              handleSelectExistingCouple(opt, "mentor_couple")
                            }
                            placeholder={t("select")}
                            isSearchable={true}
                            isClearable={true}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_first_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisFirstName"
                            id="hisFirstName"
                            placeholder={t("his_first_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.hisFirstName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "mentor_couple")
                            }
                            // readOnly={isEditAdmin}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_first_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("his_last_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="hisLastName"
                            id="hisLastName"
                            placeholder={t("his_last_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.hisLastName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "mentor_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_last_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>His Email</Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="hisEmail"
                            id="hisEmail"
                            placeholder="Email"
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.hisEmail) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "mentor_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("his_email_required")}
                          </Form.Control.Feedback>
                          {emailErrors.mentor_couple_hisEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.mentor_couple_hisEmail}
                            </span>
                          )}
                        </Form.Group>
                      </Col>

                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_first_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herFirstName"
                            id="herFirstName"
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.herFirstName) ||
                              ""
                            }
                            placeholder={t("her_first_name")}
                            onChange={(e) =>
                              handleRetreatTeam(e, "mentor_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_first_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_last_name")}</Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="herLastName"
                            id="herLastName"
                            placeholder={t("her_last_name")}
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.herLastName) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "mentor_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_last_name_required")}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={12} md={12} xs={12}>
                        <Form.Group className="form-group">
                          <Form.Label>{t("her_email")}</Form.Label>
                          <CopyableInput
                            size="sm"
                            type="text"
                            name="herEmail"
                            id="herEmail"
                            placeholder="Email"
                            value={
                              (data &&
                                data.retreat_team &&
                                data.retreat_team.find(
                                  (member) => member.role === "mentor_couple",
                                )?.herEmail) ||
                              ""
                            }
                            onChange={(e) =>
                              handleRetreatTeam(e, "mentor_couple")
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("her_email_required")}
                          </Form.Control.Feedback>
                          {emailErrors.mentor_couple_herEmail && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "12px" }}
                            >
                              {emailErrors.mentor_couple_herEmail}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Col>
                  </Row>
                  <hr></hr>
                  <Col lg={4} md={4} xs={12} className="border-right">
                    <h4>{t("spiritual_director")}</h4>
                    <Col lg={12} md={12} xs={12}>
                      <Form.Group className="form-group">
                        <div className="d-flex justify-content-between align-items-center">
                          <Form.Label>{t("select_existing_priest")}</Form.Label>

                          <Button
                            variant="primary"
                            className="btn-sm d-flex align-items-center gap-2"
                            onClick={handleAddPriestClick}
                            style={{
                              fontSize: "12px",
                              border: "none",
                              marginBottom: "7px",
                            }}
                          >
                            <i className="mdi mdi-plus-circle"></i>
                            {t("create_new_priest")}
                          </Button>
                        </div>
                        <Select
                          options={priestOptions}
                          onChange={(opt) => handleSelectExistingPriest(opt)}
                          placeholder={t("select")}
                          isSearchable={true}
                          isClearable={true}
                          value={selectedPriestOption}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={12} md={12} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label> {t("first_name")} </Form.Label>
                        <Form.Control
                          // required
                          size="sm"
                          type="text"
                          name="firstName"
                          id="firstName"
                          placeholder={t("first_name")}
                          value={
                            data.retreat_team?.find(
                              (member) => member.role === "spiritual_director",
                            )?.firstName || ""
                          }
                          onChange={(e) =>
                            handleRetreatTeam(e, "spiritual_director")
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("first_name_required")}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={12} md={12} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label> {t("last_name")} </Form.Label>
                        <Form.Control
                          // required
                          size="sm"
                          type="text"
                          name="lastName"
                          id="lastName"
                          placeholder={t("last_name")}
                          value={
                            data.retreat_team?.find(
                              (member) => member.role === "spiritual_director",
                            )?.lastName || ""
                          }
                          onChange={(e) =>
                            handleRetreatTeam(e, "spiritual_director")
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("last_name_required")}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={12} md={12} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label>{t("email")}</Form.Label>
                        <CopyableInput
                          size="sm"
                          type="text"
                          name="email"
                          id="email"
                          placeholder={t("email")}
                          value={
                            data.retreat_team?.find(
                              (member) => member.role === "spiritual_director",
                            )?.email || ""
                          }
                          onChange={(e) =>
                            handleRetreatTeam(e, "spiritual_director")
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("email_required")}
                        </Form.Control.Feedback>
                        {emailErrors.spiritual_director_email && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {emailErrors.spiritual_director_email}
                          </span>
                        )}
                      </Form.Group>
                    </Col>
                  </Col>
                  <hr></hr>

                  <Row>
                    <h3 className="mt-3 mb-3">{t("contact_info")}</h3>

                    <Col lg={4} md={4} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("enter_name")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          size="sm"
                          type="text"
                          name="contact_name"
                          id="contact_name"
                          placeholder="Contact Name"
                          value={data.contact_name}
                          onChange={(e) => handleChanges(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("contact_name_required")}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={4} md={4} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("search_mail_placeholder")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <CopyableInput
                          required
                          size="sm"
                          type="contact_email"
                          name="contact_email"
                          id="contact_email"
                          placeholder="Contact Email"
                          value={data.contact_email} // corrected to data.email
                          onChange={(e) => handleChanges(e)} // handle the onChange event
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("contact_email_required")}
                        </Form.Control.Feedback>
                        {emailErrors.contact_email && (
                          <span
                            className="text-danger"
                            style={{ fontSize: "12px" }}
                          >
                            {emailErrors.contact_email}
                          </span>
                        )}
                      </Form.Group>
                    </Col>

                    <Col lg={4} md={4} xs={12}>
                      <Form.Group className="form-group">
                        <Form.Label>
                          {t("mobile_number")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <PhoneInput
                          name="contact_mobile"
                          value={data.contact_mobile}
                          onChange={handleChanges}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t("contact_mobile_required")}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <hr className="my-3" />

                    <Col>
                      <h3 className="mt-3 mb-3">
                        {t("retreat_administrators")}
                      </h3>
                      <div className="d-flex align-items-start gap-2">
                        <Select
                          className="flex-grow-1"
                          id="couple"
                          name="couple"
                          options={allCoupleMails}
                          value={coupleSelectForAccess}
                          onChange={handleSelectOption}
                          labelledBy="Select"
                          isSearchable={true}
                          isMulti={true}
                          menuPlacement="top"
                        />
                        <div className="d-flex align-items-center">
                          {accessGreenTick ? (
                            <i
                              className="mdi mdi-check-circle text-success fs-3"
                              style={{ cursor: "default" }}
                            ></i>
                          ) : (
                            <i
                              onClick={handleAccessSubmit}
                              className="mdi mdi-plus-circle text-primary fs-3"
                              style={{ cursor: "pointer" }}
                            ></i>
                          )}
                        </div>
                      </div>

                      {data?.subAdmins?.length > 0 ? (
                        <div className="selected-couples my-3">
                          {data.subAdmins.map((item, index) => (
                            <div
                              key={index}
                              className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                            >
                              <span>{item.label}</span>
                              <i
                                className="mdi mdi-delete-forever text-danger fs-4"
                                onClick={() => handlerAccessRmvShow(item)}
                                title="Remove Couple"
                                style={{ cursor: "pointer" }}
                              ></i>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted">{t("no_couple_yet")}</p>
                      )}
                    </Col>
                    <hr className="my-3" />
                  </Row>

                  <Col lg={12} md={12} xs={12} className="text-center mt-5">
                    <Modal.Footer>
                      {userData && userData.userRole === "ADMIN" ? (
                        <>
                          <Button
                            disabled={applyLoader}
                            variant="primary"
                            type="submit"
                            onClick={() => setIsApproveAction(false)}
                            className="mx-1"
                          >
                            Save
                          </Button>
                          <Button
                            disabled={applyLoader}
                            variant="success"
                            type="submit"
                            onClick={() => setIsApproveAction(true)}
                            className="mx-1"
                          >
                            Approve
                          </Button>
                        </>
                      ) : (
                        <Button
                          disabled={applyLoader}
                          variant="primary"
                          type="submit"
                          onClick={() => setIsApproveAction(false)}
                        >
                          {t("save")}
                        </Button>
                      )}
                      {userData && userData.userRole === "ADMIN" && (
                        <Button
                          variant="danger"
                          onClick={() => {
                            handleShow(data);
                          }}
                        >
                          {t("delete")}
                        </Button>
                      )}
                      <Button
                        variant="secondary"
                        onClick={() => {
                          CloseCompose();
                        }}
                      >
                        {t("cancel")}
                      </Button>
                    </Modal.Footer>
                  </Col>
                </Form>
              </div>{" "}
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  return (
    <div className="row">
      <div className="col-lg-12 d-flex flex-column mt-1">
        <div className="card  custom-card">
          <div className="card-body">
            <div className=" mb-3 d-sm-flex justify-content-between align-items-start Couple_heading">
              <h4 className="card-title">New Retreats</h4>
              <div className="d-flex">
                <div className="search">
                  <div className="input-group setSearch">
                    <input
                      onChange={SearchData}
                      type="text"
                      className="form-control searchData"
                      placeholder="Search..."
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                    />
                    <div className="input-group-append">
                      <button className="btn btn-sm btn-primary" type="button">
                        <i className="icon-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <CustomDataTable
              data={tempRetreats}
              countPerPage={20}
              isServerSide={true}
              pagination={true}
              sortServer={true}
              total={total}
              columns={columns}
              dataFetchApi={getAllTempRetreats}
              pointerOnHover={true}
              highlightOnHover={true}
              // fixedHeader={true}
            />
            {/* } */}
          </div>
        </div>
      </div>
      {show ? (
        <DeleteModel
          show={show}
          content={
            <>
              <div className="p-3 mt-3 border rounded-3 bg-light shadow-sm">
                {/* Her Details */}
                {tempRetreatDetail && tempRetreatDetail !== "" && (
                  <div>
                    <span className="fw-bold">Retreat:</span>{" "}
                    <span>
                      {`${tempRetreatDetail.title} ${
                        moment(tempRetreatDetail.dateFrom)
                          .tz("America/New_York")
                          .format("MMM DD") +
                        " - " +
                        moment(tempRetreatDetail.dateTo)
                          .tz("America/New_York")
                          .format("MMM DD") +
                        ", " +
                        moment(tempRetreatDetail.dateFrom)
                          .tz("America/New_York")
                          .format("YYYY")
                      }`}
                    </span>
                  </div>
                )}
              </div>
            </>
          }
          handleClose={handleClose}
          DeleteData={deleteTempRetreat}
        ></DeleteModel>
      ) : null}
      {showRegModal ? renderModel() : null}
      {descriptionSample ? (
        <AlertDelete
          show={descriptionSample}
          alertHeader={t("description_sample")}
          alerMessage={
            <div>
              <DescriptionSampleTip />
              <div>
                {dynamicDescription ? (
                  <div dangerouslySetInnerHTML={{ __html: dynamicDescription }} />
                ) : data.language === "spanish" ? (
                  <div style={{ textAlign: "center" }}>
                    <p style={{ color: "rgb(53, 53, 53)", fontSize: "16px" }}>
                      El costo es de $175 por pareja. Se requiere un depósito de
                      $75 al momento de enviar el formulario de inscripción. El
                      número de parejas que podemos acomodar es limitado y la
                      disponibilidad es por orden de llegada. El costo de
                      inscripción cubre la cena del viernes, tres comidas el
                      sábado y el desayuno y almuerzo del domingo. También cubre
                      todos los materiales del retiro. No se proporciona cuidado
                      de niños.
                    </p>

                    <p>
                      <strong>
                        <em>
                          Todas las parejas del retiro deben comprometerse a
                          asistir a todas las actividades del fin de semana de 3
                          días.
                        </em>
                      </strong>
                    </p>

                    <p style={{ fontSize: "20px", color: "rgb(34, 34, 34)" }}>
                      Iglesia de San Pedro y San Pablo
                      <br />
                      386 N Castell Ave.,
                      <br />
                      New Braunfels, TX, 78130
                    </p>

                    <p>Para preguntas, aquí está la información de contacto:</p>

                    <p>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>

                    <p style={{ color: "#222222" }}>
                      Phil (210-779-3096)
                      <br />
                      Jen (210-288-1908)
                    </p>

                    <p>¡Gracias!</p>
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <p style={{ color: "rgb(53, 53, 53)", fontSize: "16px" }}>
                      The cost is $175 per couple. A $75 deposit is due with the
                      registration form. We are limited as to the number of
                      couples we can accommodate, and availability is on a first
                      come, first-serve basis. The registration cost covers
                      dinner on Friday, three meals on Saturday, and breakfast
                      and lunch on Sunday. It will also cover all retreat
                      materials. Childcare is not provided.
                    </p>

                    <p>
                      <strong>
                        <em>
                          All Retreat Couples must commit to attending the
                          entire 3-day weekend’s activities.
                        </em>
                      </strong>
                    </p>

                    <p style={{ fontSize: "20px", color: "rgb(34, 34, 34)" }}>
                      Sts. Peter and Paul Church
                      <br />
                      386 N Castell Ave.,
                      <br />
                      New Braunfels, TX, 78130
                    </p>

                    <p>For questions, here is the contact info:</p>

                    <p>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>

                    <p style={{ color: "#222222" }}>
                      Phil (210-779-3096)
                      <br />
                      Jen (210-288-1908)
                    </p>

                    <p>Thank you!</p>
                  </div>
                )}
              </div>
            </div>
          }
          handleClose={handleCloseAlert}
          buttonText={t("close")}
        />
      ) : null}

      {mailSample ? (
        <AlertDelete
          show={mailSample}
          alertHeader={t("sample_email_message")}
          alerMessage={
            <div>
              {dynamicEmailMsg ? (
                <div dangerouslySetInnerHTML={{ __html: dynamicEmailMsg }} />
              ) : data.language === "spanish" ? (
                <div style={{ textAlign: "center" }}>
                  <p>
                    Gracias por inscribirse en el retiro matrimonial LOVESTRONG
                    de San Pedro y San Pablo, programado del 18 al 20 de octubre
                    de 2024. ¡Nos entusiasma que nos acompañen!
                  </p>
                  <p>Si tienes alguna pregunta, contáctanos aquí...</p>
                  <p>
                    <strong>Correo electrónico: </strong>
                    <a
                      href="mailto:solizspp.lovestrong@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1155CC" }}
                    >
                      solizspp.lovestrong@gmail.com
                    </a>
                  </p>
                  <p style={{ color: "rgb(34, 34, 34)" }}>
                    <strong>Jen Soliz</strong>
                    <br />
                    210-288-1908
                  </p>
                  <p style={{ color: "#222222" }}>
                    <strong>Phil Soliz</strong>
                    <br />
                    210-779-3096
                  </p>
                  <p style={{ fontSize: "12px" }}>
                    Por favor, espere saber de nosotras pronto!
                  </p>
                  <p style={{ fontSize: "12px" }}>
                    <strong>¡VIVE! ¡AMA! ¡FUERTE!</strong>
                  </p>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <p>
                    Thank you for registering for the Sts. Peter and Paul
                    LOVESTRONG Marriage retreat scheduled for October 18-20,
                    2024. We are excited that you will join us!
                  </p>
                  <p>
                    If you have any questions, please reach out to us here...
                  </p>
                  <p>
                    <strong>Email: </strong>
                    <a
                      href="mailto:solizspp.lovestrong@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#1155CC" }}
                    >
                      solizspp.lovestrong@gmail.com
                    </a>
                  </p>
                  <p style={{ color: "rgb(34, 34, 34)" }}>
                    <strong>Jen Soliz</strong>
                    <br />
                    210-288-1908
                  </p>
                  <p style={{ color: "#222222" }}>
                    <strong>Phil Soliz</strong>
                    <br />
                    210-779-3096
                  </p>
                  <p style={{ fontSize: "12px" }}>
                    Please expect to hear from us soon!
                  </p>
                  <p style={{ fontSize: "12px" }}>
                    <strong>LIVE! LOVE! STRONG!</strong>
                  </p>
                </div>
              )}
            </div>
          }
          handleClose={handleCloseAlert}
          buttonText={t("close")}
        />
      ) : null}

      {mailMsgView ? (
        <ViewMailMsg
          show={mailMsgView}
          alertHeader={t("preview_email")}
          alertMessage={emailMsg}
          handleClose={() => {
            setMailMsgView(false);
          }}
          language={data.language}
        ></ViewMailMsg>
      ) : null}
      <UpdatePriestPopUp
        showRegModal={showPriestModal}
        onHide={() => setShowPriestModal(false)}
        closeButton={true}
        data={priestData}
        setData={setPriestData}
        isEditAdmin={false}
        parishList={parishList}
        setParishList={setParishList}
        ediUserIdClicked={ediUserIdClicked}
        setEdiUserIdClicked={setEdiUserIdClicked}
        setShowREgModal={setShowPriestModal}
        getAllPriests={getAllPriests}
        userData={userData}
        oldValues={oldPriestValues}
        setOldValues={setOldPriestValues}
        isTempUpload={isTempPriestUpload}
        setIsTempUpload={setIsTempPriestUpload}
        redirect={false}
        onSuccess={handlePriestSuccess}
      />
    </div>
  );
};

export default NewRetreats;
